
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[id]",
      function () {
        return require("private-next-pages/collections/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[id]"])
      });
    }
  